export { ComponentResolver } from './ComponentResolver';
export type { ComponentProps } from './ComponentResolver';
